<template>
  <div id="app" :style="{'background-color': baseColor}">

    <!-- page main wrapper start -->
    <main style="background-color:#ffffff" id="start">
        <!-- contact wrapper area start -->
    <div>
         <div class="text-center pt-20 pb-20">
                      <h1 style="color:#000000">Fout bij inladen</h1>
            </div>
    </div>
        <div class="container">
            
            <div class="row pt-30">
                <div class="col-lg-24 col-md-24 col-sm-24">
                    <div class="footer-widget text-center">
                         <div class="product-btn" >
                                <a @click="reloadPage()" style="color:#fff;background-color:#000"><i class="ion-bag" ></i>Probeer opnieuw</a>
                          </div>
                    </div>
                </div>                   
            </div>
        </div>
        <!-- contact wrapper area end -->
    </main>
  </div>
</template>


<style lang="scss">
@import '../static/sites/site-10/assets/css/style.css';
</style>

<script>

import Vue from 'vue';


export default {
  name: 'app',
  data () {
    return {
      isLoading: false,
    }
  },
  components: {
  },
  created () {

      
  },
  computed: {
  },
  methods: {
      navigate (item) {
        //this.$router.push(item);
      },
      navigateBack () {
        //this.$router.go(-1);
      },
      reloadPage () {
          location.reload(true);
      }
    },
}

</script>


<style scoped>
</style>


// WEBPACK FOOTER //
// src/AppError.vue